import MDataTable from './index.vue';

MDataTable.install = app => {
  app.component(MDataTable.name, MDataTable);
};

export default MDataTable;
